export const TAKE_PICTURE = 'TAKE_PICTURE';
export const TAKE_VIDEO = 'TAKE_VIDEO';
export const PIC_SENT = 'PIC_SENT'
export const FAILED_TO_SEND = 'FAILED_TO_SEND';